export const WORKER_START_COMMAND = 'start';
export const WORKER_STOP_COMMAND = 'stop';

export const WORKER_MESSAGE_PERIODIC_DOWNLOAD_DONE = 'localStorageTicketDownloadDone';
